export const isBoolean = (data) => typeof data === 'boolean';
